import type * as Types from '../../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type DeliverGuestNotFoundMessageMutationVariables = Types.Exact<{
  payload: Types.DeliverGuestNotFoundMessagePayload;
}>;

export type DeliverGuestNotFoundMessageMutation = { __typename?: 'Mutation'; deliverGuestNotFoundMessage?: boolean | null };

export const DeliverGuestNotFoundMessageDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeliverGuestNotFoundMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeliverGuestNotFoundMessagePayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deliverGuestNotFoundMessage' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeliverGuestNotFoundMessageMutationFn = Apollo.MutationFunction<DeliverGuestNotFoundMessageMutation, DeliverGuestNotFoundMessageMutationVariables>;

/**
 * __useDeliverGuestNotFoundMessageMutation__
 *
 * To run a mutation, you first call `useDeliverGuestNotFoundMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeliverGuestNotFoundMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deliverGuestNotFoundMessageMutation, { data, loading, error }] = useDeliverGuestNotFoundMessageMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useDeliverGuestNotFoundMessageMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DeliverGuestNotFoundMessageMutation, DeliverGuestNotFoundMessageMutationVariables>,
) {
  return ApolloReactHooks.useMutation<DeliverGuestNotFoundMessageMutation, DeliverGuestNotFoundMessageMutationVariables>(DeliverGuestNotFoundMessageDocument, baseOptions);
}
export type DeliverGuestNotFoundMessageMutationHookResult = ReturnType<typeof useDeliverGuestNotFoundMessageMutation>;
export type DeliverGuestNotFoundMessageMutationResult = Apollo.MutationResult<DeliverGuestNotFoundMessageMutation>;
export type DeliverGuestNotFoundMessageMutationOptions = Apollo.BaseMutationOptions<DeliverGuestNotFoundMessageMutation, DeliverGuestNotFoundMessageMutationVariables>;
